module.exports = __webpack_public_path__ + "img/Extension 1.7e2590fa.svg";